import styled from 'styled-components';
import { transparentize } from 'polished';
import colors from '../../theme/colors';

export const ContentWrapperStyled = styled.li`
	display: flex;
	flex-direction: column;
	&.currentSelected {
		background: ${transparentize(0.75, colors.colors.primaryColor)};
	}
	&:hover {
		cursor: pointer;
	}
	padding: ${({ theme }) => theme.variables.padding}px;
	border-bottom: 1px solid ${({ theme }) => theme.colors.quaternaryColor};
`;

export const IconWrapper = styled.figure`
	position: relative;
	background: ${({ theme }) => theme.colors.secondaryColor};
	width: 29px;
	height: 29px;
	min-width: 29px;
	min-height: 29px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	&:hover {
		cursor: pointer;
	}
`;

export const HeaderContainerStyled = styled.div`
	width: 100%;
	padding-bottom: ${({ theme }) => theme.variables.padding * 0.5}px;
`;

export const HeaderWrapperStyled = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;
`;

export const InformationContainerStyled = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;

	@media (max-width: ${({ theme }) => `${theme.variables.wrapBreakPoint}px`}) {
		flex-direction: column;
	}
`;

export const InformationWrapperStyled = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const MetricWrapperStyled = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	padding-top: ${({ theme }) => theme.variables.padding * 0.25}px;
`;
